import PropTypes from "prop-types";

const PlaceDetail = { side: PropTypes.string };

export default {
	PlaceDetail,
};
